<script>
export default defineComponent({
  name: "HowItWorks"
});
</script>
<script setup>
  function handleClick() {
    const button = document.getElementById('opero-club-form-trigger');

    button.dispatchEvent(new CustomEvent('click'));
  }
</script>

<template>
  <div class="how-it-works bg-primary mt-10 pt-10 md:pt-16 md:pb-16">
    <div class="flex justify-center">
      <div class="max-w-7xl p-6 w-full">
        <div class="how-it-works-grid md:grid grid-cols-2 gap-4">
          <div class="how-it-works-col">
            <div class="how-it-works-headline">
              <div class="how-it-works-headline__icon">
                <AnimationPaperMeet canvasWidth="70px" canvasHeight="70px" />
              </div>
              <h2 class="h1 whitespace-nowrap">
                {{ $t("membership.HowItWorks.title") }}
              </h2>
            </div>
            <div class="how-it-works-club">
              <h3>{{ $t("membership.HowItWorks.club.title") }}</h3>
              <p class="how-it-works-club__price">{{ $t("membership.HowItWorks.club.price") }}</p>
              <p class="how-it-works-club__copy">{{ $t("membership.HowItWorks.club.copy") }}</p>
              <div class="text-center">
                <button
                  @click="handleClick"
                  class="bg-transparent border rounded-full border-black text-lg text-black px-4 py-2 mt-6"
                >
                  {{ $t("want-to-try-it") }}
                </button>
              </div>
            </div>
          </div>
          <div class="how-it-works-col mt-12 md:mt-0 text-center md:text-left" v-html="$t('membership.HowItWorks.copy')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .how-it-works {
    &-grid {
      row-gap: 60px;
    }
    &-headline {
      display: flex;
      align-items: center;
      justify-content: center;

      &__icon {
        display: block;
        margin-left: -50px;
      }
    }
    &-club {
      text-align: center;
      margin-top: 40px;

      &__copy {
        font-size: 14px;
        max-width: 260px;
        margin: 0 auto !important;
      }
    }
  }
  p {
    font-size: 16px;

    @media all and (min-width: 640px) {
      font-size: 20px;
    }
  }
</style>